import { render, staticRenderFns } from "./Pause2.vue?vue&type=template&id=7470fb7d&"
import script from "./Pause2.vue?vue&type=script&lang=js&"
export * from "./Pause2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports